import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { Box, Typography } from "@outschool/backpack";
import { useIsMobile } from "@outschool/ui-utils";
import React from "react";

import curatedBelowTheFoldFrame from "../../../../images/curated-below-the-fold-frame.png";

export interface CuratedBelowTheFoldSectionProps {
  title: string | null;
  description: { json: any } | null;
}

export default function CuratedBelowTheFoldSection({
  title,
  description,
}: CuratedBelowTheFoldSectionProps) {
  const isMobile = useIsMobile();

  if (!title || !description) {
    return null;
  }

  return (
    <Box
      sx={{
        backgroundImage: `url("${curatedBelowTheFoldFrame}")`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% auto",
        borderRadius: "1em",
        backgroundColor: "primary.50",
        padding: isMobile ? "30px" : "80px",
      }}
    >
      <Typography
        variant="h3"
        sx={{
          marginBottom: "1em",
        }}
        align="center"
        emphasized
        component="h2"
      >
        {title}
      </Typography>
      <Box
        sx={{
          textAlign: "center",
        }}
      >
        {documentToReactComponents(description.json)}
      </Box>
    </Box>
  );
}
